import slugify from 'slugify';
import { Entry } from 'contentful';
import { IContentfulSection, IImage, ILink, IRichText } from '@belong/types';
import { FImage, FLink, FRichText } from '@belong/contentful';

export interface ISectionArticleHeader extends IContentfulSection<'sectionArticleHeader'> {
  heading: string;
  categoryLink?: ILink;
  autoCategoryLink?: ILink; // injected by app
  content?: IRichText;
  image?: IImage;
  link?: ILink;
  publishInfo?: any;
  hideImageOnMobile?: boolean;
}

function FSectionArticleHeader(data: Entry<any>): ISectionArticleHeader {
  const {
    categoryLink,
    content,
    heading,
    hideImageOnMobile = false,
    identifier,
    image,
    link,
    sectionStyles
  } = data.fields;

  return {
    categoryLink: categoryLink && FLink(categoryLink),
    content: content && FRichText(content),
    contentType: 'sectionArticleHeader',
    heading,
    hideImageOnMobile,
    id: data.sys.id,
    identifier: slugify(identifier),
    image: image && FImage(image),
    link: link && FLink(link),
    publishInfo: {},
    sectionStyles
  };
}

export default FSectionArticleHeader;
